export default __webpack_public_path__ + "4913672b955b50f11f088eb21cac92fe.png";